var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup",class:{
    open: _vm.open,
  }},[_c('div',{staticClass:"popup__container",class:{ 'popup__container--small': _vm.isSmall }},[_c('span',{staticClass:"popup__container__msg"},[_vm._v(_vm._s(_vm.msg))]),_c('Button',{staticClass:"popup__container__btn",attrs:{"backgroundColor":'rgb(0, 0, 0, 1)',"hoverBackgroundColor":'rgb(0, 0, 0, 0.5)',"text":_vm.buttonText || _vm.getLiteral('popUp.aceptar'),"borderRadius":"5px"},on:{"click":_vm.setClose}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }